import { render, staticRenderFns } from "./modifyManualPage.vue?vue&type=template&id=d7695b08&"
import script from "./modifyManualPage.vue?vue&type=script&lang=tsx&"
export * from "./modifyManualPage.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports